
export const CourseType = {
    Masterclass: "masterclass",
    Professional: "professional",
    Bootcamp: "bootcamp",
}

export const CourseStatus = {
    ToStart: "to_start",
    InProgress: "in_progress",
    Ended: "ended"
}

export const LessonStatus = {
    ToStart: "to_start",
    Live: "live",
    Ended: "ended",
    All: ["live", "to_start", "ended"]
}

export const TagType = {
    General: "general",
    Feature: "feature"
}

export const ArticleCardType = {
    Large: "large",
    Medium: "medium",
    Small: "small"
}

export const FeedType = {
    Lesson: "lesson",
    Exercise: "exercise",
    Material: "material",
    Communication: "communication",
    Test: "test"
}

export const palette = [
  // 🌊 Blu & Azzurri
  '#89C5E9', // azzurro ceruleo
  '#93CADB', // azzurro pastello originale
  '#A5BCE0', // blu polvere
  '#95A8C8', // blu acciaio

  // 💜 Viola & Lilla
  '#CAABD4', // lilla chiaro
  '#B7A8E3', // lavanda fredda
  '#C7B8E0', // pervinca
  '#D6A7CC', // malva
  '#c98bcfff', // viola pastello originale

  // 🌿 Verdi & Turchesi
  '#2fc6a0', // verde acqua
  '#AEE6B6', // verde menta
  '#99D3A6', // verde giada
  '#B9CBB5', // verde salvia
  '#ABC760', // verde lime tenue
  '#A7B7A3', // grigio-verde neutro

  // 🌞 Gialli & Aranciati
  '#FFD600', // giallo vivo
  '#E8D479', // senape tenue
  '#EBAE87', // terracotta
  '#FFB67F', // arancio bruciato
  '#FFC9A9', // albicocca chiaro

  // ❤️ Rossi & Rosati
  '#FF9A8C', // rosa corallo
  '#FFA78A', // corallo tenue
  '#F59B9B', // rosso carminio chiaro

  // 🤎 Neutri & Grigi
  '#C8B6A6', // cacao chiaro
  '#D6D2C4', // grigio sabbia
  '#B0B6BC', // grigio ardesia
]

function darkenColor(hex, amount = 0.3) {
  const num = parseInt(hex.slice(1), 16);
  const r = Math.round(((num >> 16) & 0xff) * (1 - amount));
  const g = Math.round(((num >> 8) & 0xff) * (1 - amount));
  const b = Math.round((num & 0xff) * (1 - amount));
  const darkened = (1 << 24) | (r << 16) | (g << 8) | b;
  return `#${darkened.toString(16).slice(1)}`;
}

export const darkPalette = palette.map(color => darkenColor(color, 0.4));

export const Stripe = {
    publicKey: 'pk_test_51OkqgmHGtSMxXXMSjWJSEeMgIsM2adVltIURTRJcNYUvJfGKr262V0qCTx1aMu29EMDQ7qkHdXVkwW1Y2Vv5Jy8b00q4ZoPPYN'
}

export const PaymentStatus = {
    Succeeded: 'succeeded',
    Failed: 'failed',
    Pending: 'pending',
    Refunded: 'refunded',
    Processing: 'processing'
}

export const NotificationType = {
    LessonLive: 'lesson_live',
    LessonEdit: 'lesson_edit',
    ExerciseReminder: 'exercise_reminder',
    ExerciseResult: 'exercise_result',
    ExerciseExpired: 'exercise_expired',
    MaterialUpload: 'material_upload',
    CourseCompleted: 'course_completed',
    Announcement: 'announcement'
}

export const ButtonStatus = {
    Loading: "loading",
    Success: "success",
    Error: "error"
}

export const ProfileType = {
    User: "user",
    Teacher: "teacher",
    Admin: "admin"
}

export const EditionStatus = {
    Draft: "draft",
    Public: "public",
    Hidden: "hidden",
    Ended: "ended",
    Locked: "locked"
}

export const FileType = {
    Image: "image",
    Video: "video",
    All: "all"
}

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\]_\-])[A-Za-z\d!@#$%^&*(),.?":{}|<>[\]_\-]{8,}$/;

export const LessonState = {
    TooEarly: "too_early",
    Live: "live",
    Ended: "ended",
}

export const DailyAccessState = {
    Unknown: "unknown",
    None: "none",
    Lobby: "lobby",
    Full: "full"
}